(function () {
  if (window.__pxmGlobalNavigationReady) return;
  window.__pxmGlobalNavigationReady = true;

  function openMenus() {
    return document.querySelectorAll('.pxm-global-nav__more[open]');
  }

  document.addEventListener('click', function (event) {
    openMenus().forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    openMenus().forEach(function (menu) {
      menu.removeAttribute('open');
      var trigger = menu.querySelector('summary');
      if (trigger) trigger.focus();
    });
  });
})();
